/* eslint-disable */

import { X, Settings, LogOut } from "lucide-react";
import Links from "./components/Links";
import {
    renderThumb,
    renderTrack,
    renderView,
} from "components/scrollbar/Scrollbar";
import { Scrollbars } from "react-custom-scrollbars-2";
import routes from "routes";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "assets/img/logo.png";

const SidebarHorizon = (props: {
    open: boolean;
    onClose?: React.MouseEventHandler<HTMLSpanElement>;
    variant?: string;
    fullSidebar?: boolean;
}) => {
    const { open, onClose, variant, fullSidebar } = props;
    const nav = useNavigate();
    const [subAccounts, setSubAccounts] = useState<any>([]);
    const [showSubAccounts, setShowSubAccounts] = useState(false);
    const [selectedSubAccount, setSelectedSubAccount] = useState<any>(null);

    const handleSubAccountChange = async (id: any) => {
        localStorage.setItem("id", id);
        setSelectedSubAccount(id);
    };

    useEffect(() => {
        const adminToken = localStorage.getItem("admin-token");
        const isAdmin = localStorage.getItem("isAdmin");
        const id = localStorage.getItem("id");
        if (id) setSelectedSubAccount(id);
        if (isAdmin === "true" || adminToken) {
            // Copy token to admin-token
            if (!adminToken) {
                const token = localStorage.getItem("token");
                localStorage.setItem("admin-token", token);
            }
        }
    }, []);

    return (
        <aside
            // A rounded rail a shade lighter than the page. From xl it runs the full height beside the
            // top bar (which then starts after it) and carries the logo; below xl it is the drawer.
            className={`fixed left-8 top-[68px] h-[calc(100vh-5rem)] rounded-3xl bg-[#FCF9F7] transition-all duration-300 xl:left-6 xl:top-2 xl:z-[60] xl:h-[calc(100vh-1rem)] ${
                variant === "auth" ? "xl:hidden" : "xl:block"
            } ${open ? "z-40" : "-translate-x-[calc(100%+2rem)]"} ${
                fullSidebar ? "w-[100px]" : "w-16"
            }`}
        >
            <div className="flex flex-col h-full">
                <Scrollbars
                    autoHide
                    renderTrackVertical={renderTrack}
                    renderThumbVertical={renderThumb}
                    renderView={renderView}
                >
                    <div className="flex h-full flex-col justify-between pb-4 pt-4">
                        <div>
                            {/* Close button for mobile */}
                            <span
                                className="absolute right-1 top-1 cursor-pointer xl:hidden"
                                onClick={onClose}
                            >
                                <X className="w-4 h-4 text-ink hover:text-ink-muted transition-colors duration-150" />
                            </span>

                            {showSubAccounts && fullSidebar && (
                                <div className="px-4 mb-4">
                                    <select
                                        name="HeadlineAct"
                                        id="HeadlineAct"
                                        className="w-full rounded-lg border-border text-ink text-sm py-2 px-3"
                                        onChange={(e) =>
                                            handleSubAccountChange(
                                                e.target.value,
                                            )
                                        }
                                    >
                                        {subAccounts?.map((subAccount: any) => (
                                            <option
                                                key={subAccount.id}
                                                value={subAccount.id}
                                                selected={
                                                    subAccount.id ===
                                                    selectedSubAccount
                                                }
                                            >
                                                {subAccount.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}

                            <button
                                type="button"
                                onClick={() => nav("/dashboard")}
                                aria-label="Duckflow, accueil"
                                className="mx-auto mb-4 hidden h-11 w-11 items-center justify-center rounded-[14px] bg-surface-inverse transition-opacity duration-150 hover:opacity-85 xl:flex"
                            >
                                <img src={logo} alt="" className="h-6 w-6 object-contain invert" />
                            </button>

                            {/* Navigation Links */}
                            <nav className="px-2.5">
                                <Links
                                    routes={routes}
                                    fullSidebar={fullSidebar}
                                    onNavClicked={onClose}
                                />
                            </nav>
                        </div>

                        {/* Bottom actions - only show on mobile */}
                        {fullSidebar && (
                            <div className="xl:hidden pt-4 mt-4">
                                <div className="flex flex-col gap-1 px-2">
                                    <button
                                        onClick={() => nav("/settings")}
                                        className="flex flex-col items-center gap-1.5 rounded-2xl px-1 py-2.5 text-xs leading-4 font-medium text-ink-muted hover:bg-surface-sunken/60 transition-colors duration-150"
                                    >
                                        <Settings className="w-[22px] h-[22px] text-ink/80" />
                                        <span>Réglages</span>
                                    </button>
                                    <button
                                        onClick={() => {
                                            localStorage.removeItem("token");
                                            localStorage.removeItem("isAdmin");
                                            localStorage.removeItem("admin-token");
                                            nav("/auth/login");
                                        }}
                                        className="flex flex-col items-center gap-1.5 rounded-2xl px-1 py-2.5 text-xs leading-4 font-medium text-danger hover:bg-danger-subtle transition-colors duration-150"
                                    >
                                        <LogOut className="w-[22px] h-[22px]" />
                                        <span>Sortir</span>
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </Scrollbars>
            </div>
        </aside>
    );
};

export default SidebarHorizon;
